module.exports = "/assets/data/46fd17963470a8c40a56833a914b6ba0-FK10.data.json";